<template>
	<div class="content">
		<div class="backgo" @click="back()"><img src="../../assets/img/back.png" alt=""><div>返回</div></div>
		<div class="cont_title">学生列表</div>
		<div class="className">
			<div class="className_item">
				<div class="className_item_left">班级名称</div>
				<div class="className_item_right">{{info.class_name}}</div>
			</div>
			<div class="className_item">
				<div class="className_item_left">所属院系</div>
				<div class="className_item_right">{{info.department_name}}</div>
			</div>
		</div>
		<div class="top">
			
			<el-input style="width: 280px;margin-right: 30px;" 
			v-model="queryParams.keywords" @keyup.enter.native="getList" placeholder="请输入学生姓名\学号查询" type="text"/>
			<el-button icon="el-icon-search" type="primary" @click="getList()">查询</el-button>
			<div class="top_rig">
				<div class="zujuan_btn" @click="goEdit()">
					<img src="../../assets/img/tea4.png" alt="">
					<div>编辑学生</div>
				</div>
			</div>
		</div>
		<el-table style="width: 100%;margin-top: 30px;" border :data="tableData" :header-cell-style="{background: '#F5F6F7'}">
			<el-table-column prop="student_code" label="学号" align="center"/>
			<el-table-column prop="student_name" label="姓名" align="center"/>
			<el-table-column prop="class_name" label="班级" align="center"/>
			<el-table-column  label="性别" align="center">
				<template slot-scope="scope">
					<span v-if="scope.row.sex == 1">男</span>
					<span v-else>女</span>
				</template>
			</el-table-column>
			<el-table-column prop="phone" label="联系方式" align="center"/>
			<el-table-column  label="学习统计" align="center">
				<template slot-scope="scope">
					<el-button @click="goDetails(scope.row)" type="text" size="small">查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="block" style="margin-top: 20px;text-align: center;">
			<el-pagination background  @current-change="handleCurrentChange" 
			:current-page="currentPage" layout="prev, pager, next" :total="total"></el-pagination>
		</div>
		
	</div>
</template>
<script>
import {student_list} from "../../api/new.js";		
	export default {
		data() {
			return {
				info:'',
				loading: false,
				tableData: [],
				queryParams:{
					keywords:'',
					limit:10,
					page:1,
					banji_id:'',
				},
				total: 0,
				currentPage: 1,
			};
		},
		mounted() {
			this.info = JSON.parse(this.$route.query.info)
			this.queryParams.banji_id = this.info.id
			this.getList()
		},
		methods: {
			back(){
				this.$router.go(-1);
			},
			//列表
			getList(){
				var _this = this
				this.loading = true
				student_list(this.queryParams).then((res) => {
					this.loading = false
					if (res.code == 0) {
						this.tableData = res.data
						this.total = res.total
					} else {
						this.$message.error(res.msg);
					} 
				})
				.catch((err) => {
					this.loading = false
				});	
			},
			goEdit(){
				this.$router.push({path: "/bStudentEdit"});
			},
			goDetails() {
				this.$router.push({
				  path: "/sStudentInfo",
				  query: {
				    id: "1",
				  },
				});
			},
			//上一页，下一页
			handleCurrentChange(currentPage) {
				this.queryParams.page = currentPage;
				this.currentPage = currentPage;
				this.getList()
			}
		},
	};
</script>
<style lang="less" scoped>
div{
	box-sizing: border-box;
}
.content{
	width: 100%;
	min-width: 1200px;
	background: #FFFFFF;
	border-radius: 20px;
	padding: 30px;	
	
	.top{
		width: 100%;
		display: flex;
		align-items: center;
		// justify-content: space-between;
		margin-top: 50px;
		.top_rig{
			display: flex;
			margin-left: auto;
		}
		.zujuan_btn{
			width: 140px;
			height: 44px;
			background: #4076F3;
			border-radius: 10px;
			font-size: 16px;
			color: #FFFFFF;
			line-height: 44px;
			text-align: center;
			cursor: pointer;
			margin-left: 35px;
			display: flex;
			align-items: center;
			justify-content: center;
			img{
				width: 24px;
				height: 24px;
				margin-right: 6px;
			}
		}
		.btn1{
			background: #ED7F26;
		}
		.btn2{
			background: #E13049;
		}
		.zujuan_btn:hover{
			opacity: 0.7;
		}
		.zujuan_btn:active{
			opacity: 0.9;
		}
	}
	
}	
</style>



// WEBPACK FOOTER //
// src/components/banji/bStudent.vue